import React, { Fragment } from "react";
import Header from "./common/header-component/header";
import Sidebar from "./common/sidebar-component/sidebar";
import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import Footer from "./common/footer";
import NotificationHandler from "./utils/notificationHandler/notificationHandler";
import { GoogleMapsProvider } from "../providers/GoogleMapsProvider";

const AppLayout = () => {
  return (
    <Fragment>
      <NotificationHandler />
      <GoogleMapsProvider>
      <div className="page-wrapper">
        <div className="page-body-wrapper">
          <Header />
          <Sidebar />
          <div className="page-body">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
      </GoogleMapsProvider>
      <ToastContainer />
    </Fragment>
  );
};

export default AppLayout;
